<template>

    <sorting
        :sort-uri="route('api.v1.projects.sort.index')"
        :update-uri="route('api.v1.projects.sort.update')"
    ></sorting>

</template>

<script>

    import Sorting from "../../components/Projects/Sorting";

    export default {

        components: {
            Sorting,
        },

        metaInfo: {
            title:'Sort projects',
        },

        name:'ProjectsSort',

    }

</script>
